import axios, { AxiosInstance, ResponseType } from 'axios';

export enum GraphApiEndpoint {
  V1 = 'v1.0',
  Beta = 'beta',
}

export function createGraphApi(
  authToken: string,
  endpoint: GraphApiEndpoint = GraphApiEndpoint.V1,
  responseType?: ResponseType,
): AxiosInstance {
  return axios.create({
    headers: { Authorization: 'Bearer ' + authToken },
    baseURL: `https://graph.microsoft.com/${endpoint}`,
    responseType,
  });
}
